function Modal({ isOpen, onClose, message, title, children }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white dark:bg-black bg-opacity-70 dark:bg-opacity-90 border border-white/15 rounded-2xl text-center p-4 sm:p-6 max-w-sm w-full shadow-2xl" onClick={(e) => e.stopPropagation()}>
        {title && (
          <h2 className="text-xl font-bold text-blue-800 dark:text-blue-200 mb-4 text-center">{title}</h2>
        )}
        {children || (
          <p className="text-gray-700 dark:text-white text-center text-sm leading-relaxed">{message}</p>
        )}
      </div>
    </div>
  );
}

export { useModal } from '../contexts/ModalContext';

export default Modal;
